import { Grid } from '@mui/material';
import { useKioskTileContentStyles } from './kiosk-tile-content.styles';
import { useEnvironment } from '../../../../../core/env/environment.context';
import { EnvironmentType } from '../../../../../core/env/environment-type.enum';
import { KnownHubDetailsDtoType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { LockerpointLogo } from '../../icons/LockerpointLogo.icon';

export enum ScreenOrientation {
  Portrait = 'portrait',
  Landscape = 'landscape'
}

export type KioskTileContentProps = {
  screenOnly?: boolean;
  hubType?: KnownHubDetailsDtoType;
  kioskScreenOrientation?: ScreenOrientation;
};

export function KioskTileContent({
  screenOnly,
  hubType,
  kioskScreenOrientation = ScreenOrientation.Portrait
}: KioskTileContentProps) {
  const environment = useEnvironment();
  const classes = useKioskTileContentStyles({ kioskScreenOrientation });
  const Icon = hubType === KnownHubDetailsDtoType.LockersHubExternal ? LockerpointLogo : undefined;
  const logoFileName = environment.type === EnvironmentType.Production ? 'logo' : 'logo-test';
  return (
    <Grid
      className={classes.root}
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      {screenOnly ? null : (
        <Grid>
          <div className={classes.kioskLight}></div>
        </Grid>
      )}
      <Grid>
        <div className={classes.kioskScreen}>
          {Icon ? (
            <Icon style={{ width: '32px' }} />
          ) : (
            <img
              className={classes.icon}
              src={`/media/brands/${environment.brandId}/${logoFileName}.png`}
              alt={environment.title}
            />
          )}
        </div>
      </Grid>
      {screenOnly ? null : (
        <Grid>
          <div className={classes.kioskScanner}></div>
        </Grid>
      )}
    </Grid>
  );
}
